import React, { forwardRef } from 'react'

const Modal = forwardRef((props, ref) => {
    const {
        customStyle,
        title,
        subtitle,
        children,
        footer,
        onClose,
        size,
        customClass,
        showCloseButton = true,
        showBody = true,
        showFooter = true,
        customId = 'general-modal-comp',
        gtmLabel,
        customClassFooter
    } = props

    let dialogClasses = ''

    switch (size) {
        case 'small':
            dialogClasses += ' modal-sm'
            break
        case 'medium':
            dialogClasses += ' modal-md'
            break
        case 'large':
            dialogClasses += ' modal-lg'
            break
        case 'xl':
            dialogClasses += ' modal-xl'
            break
        default:
            dialogClasses += ' modal-lg'
    }

    if (customClass) {
        dialogClasses += ' ' + customClass
    }

    return (
        <div id={customId} gtm-label={gtmLabel}>
            <div className={'modal modal-new-version-experience fade show ' + customClass} tabIndex="-1" role="dialog" data-backdrop="static" style={{ display: 'block' }}>
                <div className="full-overlay" onClick={onClose} />
                <div className={'modal-dialog' + dialogClasses} data-cy="global__modal_dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div style={{ width: showCloseButton ? 'auto' : '100%' }}>
                                <h5 className="modal-title" data-cy="modal__title">
                                    {title}
                                </h5>
                                {subtitle && <span>{subtitle}</span>}
                            </div>
                            {showCloseButton && (
                                <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                    <i className="fal fa-times" />
                                </button>
                            )}
                        </div>

                        <hr className="modal-content__divider" />

                        {showBody && (
                            <div className="modal-body" ref={ref} style={customStyle}>
                                {children}
                            </div>
                        )}
                        {showFooter && <div className={'modal-footer ' + customClassFooter}>{footer}</div>}
                    </div>
                </div>
            </div>
        </div>
    )
})

export default Modal
